'use client';

import Image from 'next/image';
import Link from 'next/link';
import { useTranslation } from '@/hooks/useTranslations';
import { EXTERNAL_LINKS, HOME_ANCHORS, ROUTES } from '@/constants/routes';
import './Footer.scss';

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__top">
          <div className="site-footer__brand">
            <Link
              href={ROUTES.HOME}
              className="site-footer__logo"
              aria-label={t('footer.homeAriaLabel')}
            >
              <Image
                src="/shift.svg"
                alt={t('footer.logoAlt')}
                width={140}
                height={42}
                className="site-footer__logo-image"
              />
            </Link>
            <p className="site-footer__tagline">{t('footer.tagline')}</p>
            <div className="site-footer__social">
              <a
                href={EXTERNAL_LINKS.INSTAGRAM}
                className="site-footer__social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t('footer.instagramAriaLabel')}
              >
                <Image
                  src="/instagram-icon.svg"
                  alt=""
                  width={20}
                  height={20}
                  className="site-footer__social-icon"
                  aria-hidden
                />
              </a>
              <a
                href={EXTERNAL_LINKS.LINKEDIN}
                className="site-footer__social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t('footer.linkedinAriaLabel')}
              >
                <Image
                  src="/linkedin-icon.svg"
                  alt=""
                  width={20}
                  height={20}
                  className="site-footer__social-icon"
                  aria-hidden
                />
              </a>
            </div>
          </div>

          <div className="site-footer__columns">
            <div className="site-footer__column">
              <h3 className="site-footer__column-title">{t('footer.columns.product')}</h3>
              <ul className="site-footer__column-list">
                <li>
                  <Link href={ROUTES.HOME} className="site-footer__link">
                    {t('footer.links.hiringPage')}
                  </Link>
                </li>
                <li>
                  <a href={HOME_ANCHORS.PRICING} className="site-footer__link">
                    {t('footer.links.pricing')}
                  </a>
                </li>
              </ul>
            </div>

            <div className="site-footer__column">
              <h3 className="site-footer__column-title">{t('footer.columns.company')}</h3>
              <ul className="site-footer__column-list">
                <li>
                  <a href={HOME_ANCHORS.ABOUT} className="site-footer__link">
                    {t('footer.links.about')}
                  </a>
                </li>
                <li>
                  <a href={EXTERNAL_LINKS.CONTACT_EMAIL} className="site-footer__link">
                    {t('footer.links.contact')}
                  </a>
                </li>
              </ul>
            </div>

            <div className="site-footer__column">
              <h3 className="site-footer__column-title">{t('footer.columns.workers')}</h3>
              <ul className="site-footer__column-list">
                <li>
                  <a href={HOME_ANCHORS.LOOKING_FOR_WORK} className="site-footer__link">
                    {t('footer.links.getTheApp')}
                  </a>
                </li>
                <li>
                  <a href={EXTERNAL_LINKS.CONTACT_EMAIL} className="site-footer__link">
                    {t('footer.links.support')}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="site-footer__bottom">
          <p className="site-footer__copyright">
            {t('footer.copyright', { year })}
          </p>
          <div className="site-footer__legal">
            <Link href={ROUTES.PRIVACY} className="site-footer__legal-link">
              {t('footer.privacy')}
            </Link>
            <Link href={ROUTES.TERMS} className="site-footer__legal-link">
              {t('footer.terms')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
